import { MandatoryFacetsMap } from '@/constants/facets';
import Service from '@/lib/App';

const makeFacetMap = (array) =>
  array.reduce(
    (obj, item) => ({
      ...obj,
      [item.name]: item.title,
    }),
    {},
  );

export function FacetsForName(): { [key: string]: string } {
  return makeFacetMap(Service.cache!.getAllFacets());
}

export const getMandatoryFacetsByDomain = (domain: string) => {
  return MandatoryFacetsMap?.[domain] || [];
};
